var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCortex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 38C20.287 38 16.726 36.525 14.1005 33.8995C11.475 31.274 10 27.713 10 24C10 20.287 11.475 16.726 14.1005 14.1005C16.726 11.475 20.287 10 24 10L24 16.0276C21.8856 16.0276 19.8578 16.8676 18.3627 18.3627C16.8676 19.8578 16.0276 21.8856 16.0276 24C16.0276 26.1144 16.8676 28.1422 18.3627 29.6373C19.8578 31.1324 21.8856 31.9724 24 31.9724L24 38Z",
    fill: "#00CC66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9986 16.0566C25.0416 16.0566 26.0743 16.2621 27.0379 16.6612C28.0015 17.0603 28.877 17.6453 29.6145 18.3828C30.3519 19.1203 30.9369 19.9958 31.3361 20.9594C31.7352 21.9229 31.9406 22.9557 31.9406 23.9986C31.9406 25.0416 31.7352 26.0743 31.3361 27.0379C30.9369 28.0015 30.3519 28.877 29.6144 29.6145C28.877 30.352 28.0014 30.937 27.0379 31.3361C26.0743 31.7352 25.0416 31.9406 23.9986 31.9406L23.9986 23.9986L23.9986 16.0566Z",
    fill: "#00CC66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCortex);
export default __webpack_public_path__ + "static/media/Cortex.d1ddbbd8399b5118cc454dc95f4daa43.svg";
export { ForwardRef as ReactComponent };